/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CustomerWalletHoldsPathParams, CustomerWalletHoldsResponse } from '../types/CustomerWalletHolds'

/**
 * GET /:organisation/wallet/holds
 * @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::holds
 */
export async function customerWalletHolds(
	organisation: CustomerWalletHoldsPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomerWalletHoldsResponse>> {
	return axiosInstance.get(`/${organisation}/wallet/holds`, config)
}
